module.exports = __webpack_public_path__ + "media/src/images/social-fb-869275e8589c37aff561a0f503fac3f4.svg";